import { makeAutoObservable } from "mobx"

import { UserAndGroup } from "@framework/types/user"

import PaginatedCollectionStore from "./paginated-collection.store"

class EntityPermissionsStore {
  unassignedEntitiesStore: PaginatedCollectionStore<UserAndGroup>

  permittedEntitiesStore: PaginatedCollectionStore<UserAndGroup>

  get isLoading() {
    return (
      this.isUpdating ||
      this.unassignedEntitiesStore.isLoading ||
      this.permittedEntitiesStore.isLoading
    )
  }

  isUpdating: boolean = false

  error: string | null = null

  constructor() {
    this.unassignedEntitiesStore = new PaginatedCollectionStore()
    this.permittedEntitiesStore = new PaginatedCollectionStore()

    makeAutoObservable(this)
  }

  setLoading(loading: boolean) {
    this.isUpdating = loading
  }

  setError(error: string | null) {
    this.error = error
  }
}

export default EntityPermissionsStore
